import React from 'react';
import PropTypes from 'prop-types';
import { SFServices } from 'utils/types';
import css from './ServicesSection.scss';
import ServicesCard from './ServicesCard';
import Title from '../../../common/Title';
import { determineServiceName } from 'utils/search';

export default class ServicesSection extends React.Component {

  hasTitle() {
    return typeof this.props.sectionName !== "undefined" && this.props.sectionName !== "";
  }

  get title() {
    return this.hasTitle() ? <Title text={this.props.sectionName} lineHeight="24px" /> : null;
  }

  get sectionId() {
    return this.hasTitle() ? this.props.sectionName.split(" ").join("-") : null;
  }

  get services() {
    const width = window.innerWidth;

    // This function will clone a card adding a "hidden" attribute and a unique id.
    // This is a hack in order to make flexbox arrange cards correctly in an unknown number
    // of elements in a row. Basically we add hidden elements that will complete the size of
    // the row based on viewport. This way all cards are aligned and we avoid having spaced
    // cards and weird margins.
    const createOffset = card => Object.assign({}, card, { hidden: true, id: `${card.id}copy` });
    if (
      (width >= 1200 && width < 1920 && this.props.services.length % 3 === 2) ||
      (width >= 1920 && this.props.services.length % 4 === 3) ) {
      return this.props.services.concat([createOffset(this.props.services[0])]);
    } else if ( width >= 1920 && this.props.services.length % 4 === 2 ) {
      return this.props.services.concat([
        createOffset(this.props.services[0]),
        createOffset(this.props.services[1])
      ]);
    }
    return this.props.services;
  }

  displayVirtualCheckInLink(service) {
    return this.props.responsiveKioskEnabled && this.props.virtualCheckInEnabled && service.virtualCheckInEnabled
  }

  render() {
    return (
      <div className={css['section-container']} id={this.sectionId} role="application">
        {this.title}
        <div className={css["cards-container"]}>
          {this.services.map(service => (
            <div key={service.id} style={{visibility: service.hidden ? "hidden" : null}}>
              <ServicesCard
                id={service.id}
                serviceUuid={service.uuid}
                name={determineServiceName(service.name, service.serviceDisplayName, this.props.isStudent)}
                serviceDescription={service.serviceDescription}
                kioskQueueSize={service.kioskQueueSize}
                kioskMaxWaitTime={service.kioskMaxWaitTime}
                onlineSchedulingAvailable={service.onlineSchedulingAvailable}
                serviceCalendarEnabled={service.serviceCalendarEnabled}
                url={service.url}
                email={service.email}
                phoneNumber={service.phoneNumber}
                kioskId={service.kioskId}
                displayStudentQueue={service.displayStudentQueue}
                kioskType={service.kioskType}
                isServiceMember={this.props.isServiceMember}
                isStaff={this.props.isStaff}
                isStudent={this.props.isStudent}
                displaySmartThinkingLink={service.displaySmartThinkingLink}
                canSeeStudentServices={this.props.canSeeStudentServices}
                canMakeAppointment={this.props.canMakeAppointment}
                hasConnectLicense={this.props.hasConnectLicense}
                virtualCheckInEnabled={this.displayVirtualCheckInLink(service)}
                checkedIntoService={service.checkedIntoService}
                virtualCheckInOpen={service.virtualCheckInOpen}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

ServicesSection.propTypes = {
  sectionName: PropTypes.string,
  services: SFServices.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  canSeeStudentServices: PropTypes.bool,
  canMakeAppointment: PropTypes.bool,
  hasConnectLicense: PropTypes.bool,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool,
  checkedIntoService: PropTypes.bool
};
